'use client';
export { SingletonHooksContainer } from 'react-singleton-hook';
